/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { useDir as n } from "@progress/kendo-react-common";
const r = "data-slider-label", s = (t) => {
  const l = e.useRef(null), i = n(l), c = t.vertical ? { bottom: `${t.position}%` } : { [i === "rtl" ? "right" : "left"]: `${t.position}%` }, a = t.vertical ? "k-tick-vertical" : "k-tick-horizontal";
  return /* @__PURE__ */ e.createElement(
    "li",
    {
      ref: l,
      className: `k-tick k-tick-large ${a}`,
      title: t.title,
      style: {
        zIndex: 1,
        position: "absolute",
        ...c
      }
    },
    t.children && /* @__PURE__ */ e.createElement(
      "span",
      {
        [r]: !0,
        className: "k-label",
        onClick: t.onClick
      },
      t.children
    )
  );
};
export {
  r as SLIDER_LABEL_ATTRIBUTE,
  s as SliderLabel
};
